import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "v-card-header" }
const _hoisted_2 = { class: "trezo-table-content" }
const _hoisted_3 = { class: "trezo-table" }
const _hoisted_4 = { class: "text-body" }
const _hoisted_5 = { class: "customer-info d-flex align-items-center" }
const _hoisted_6 = { class: "img" }
const _hoisted_7 = { class: "d-block text-black fw-medium" }
const _hoisted_8 = { class: "text-body" }
const _hoisted_9 = { class: "text-body" }
const _hoisted_10 = { class: "text-body" }
const _hoisted_11 = { class: "text-body" }
const _hoisted_12 = { class: "text-body" }
const _hoisted_13 = { class: "action-buttons d-flex align-items-center" }
const _hoisted_14 = { type: "button" }
const _hoisted_15 = { class: "material-symbols-outlined" }
const _hoisted_16 = { type: "button" }
const _hoisted_17 = { class: "material-symbols-outlined" }
const _hoisted_18 = { type: "button" }
const _hoisted_19 = { class: "material-symbols-outlined" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_PaginationTwo = _resolveComponent("PaginationTwo")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, { class: "customers-list trezo-card border-radius d-block bg-white border-0 shadow-none" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "input-search d-block",
            placeholder: "Search member here.....",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event))
          }, null, 512), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _cache[2] || (_cache[2] = _createElementVNode("button", { type: "submit" }, [
            _createElementVNode("i", { class: "material-symbols-outlined" }, "search")
          ], -1))
        ], 32)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_v_table, null, {
            default: _withCtx(() => [
              _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", { class: "text-start" }, "ID"),
                  _createElementVNode("th", { class: "text-start" }, "Member"),
                  _createElementVNode("th", { class: "text-start" }, "Email"),
                  _createElementVNode("th", { class: "text-start" }, "Phone"),
                  _createElementVNode("th", { class: "text-start" }, "Location"),
                  _createElementVNode("th", { class: "text-start" }, "Joining Date"),
                  _createElementVNode("th", { class: "text-start" }, "Last Active"),
                  _createElementVNode("th", { class: "text-start" }, "Action")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredItems, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(item.id), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createVNode(_component_v_img, {
                            class: "rounded-circle",
                            src: item.member.image,
                            alt: "customer-image"
                          }, null, 8, ["src"])
                        ]),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.member.name), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(item.email), 1),
                    _createElementVNode("td", _hoisted_9, _toDisplayString(item.phone), 1),
                    _createElementVNode("td", _hoisted_10, _toDisplayString(item.location), 1),
                    _createElementVNode("td", _hoisted_11, _toDisplayString(item.joiningDate), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(item.lastActive), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("button", _hoisted_14, [
                          _createElementVNode("i", _hoisted_15, _toDisplayString(item.action.view), 1)
                        ]),
                        _createElementVNode("button", _hoisted_16, [
                          _createElementVNode("i", _hoisted_17, _toDisplayString(item.action.edit), 1)
                        ]),
                        _createElementVNode("button", _hoisted_18, [
                          _createElementVNode("i", _hoisted_19, _toDisplayString(item.action.delete), 1)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PaginationTwo, { items: "10" })
        ])
      ])
    ]),
    _: 1
  }))
}